export default "__VITE_ASSET__BFTzEIZ6__"